export default __webpack_public_path__ + "static/media/746.9ce598f9.png";